<template>
  <v-layout row justify-center align-start>
    <v-card class="playables-container pb-3" xs6>
      <v-toolbar card>
        <v-btn icon @click="handleBackButton">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-toolbar>
      <template v-if="playable">
        <playable-list-item :data="playable" class="mt-2 mb-2" hide-screenshot></playable-list-item>
        <v-divider class="mt-3 mb-3"></v-divider>
        <div class="playable-iframe-container pl-3 pr-3" ref="iframe_container">
          <iframe :src="playable.url" :height="iframeHeight"></iframe>
        </div>
        <v-divider class="mt-3 mb-3"></v-divider>
        <v-layout row wrap>
          <v-flex md5 sm12 xs12>
            <qr-code class="ml-3 mb-3" :text="playable.url"></qr-code>
          </v-flex>
          <v-flex class="pl-3 playable-links" md3 sm12 xs12>
            <b class="links-title mb-3">Links:</b>
            <a :href="playable.url" class="playable-link">index.html</a><br>
            <template v-for="link in playableLinks">
              <a :href="link.url" target="_blank" class="playable-link">{{link.name}}</a>
            </template>
          </v-flex>
          <v-flex class="pl-3 playable-links" md2 sm12 xs12>
            <b class="links-title mb-3">Screenshots:</b>
            <template v-for="(value, key) in playableScreenshots">
              <a :href="value" target="_blank" class="playable-link">{{key}}</a>
            </template>
          </v-flex>
        </v-layout>
<!--        <v-layout>-->
<!--          <v-flex md5 sm12 xs12>-->
<!--            <update-screenshot-button :playable-id="playable.id"></update-screenshot-button>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
      </template>
      <template v-if="isLoading">
        <v-layout justify-center align-center class="pb-4 pt-4">
          <v-progress-circular :indeterminate="true"></v-progress-circular>
        </v-layout>
      </template>
    </v-card>
  </v-layout>
</template>

<script>
import PlayableListItem from '@/components/PlayablesListItem.vue'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import UpdateScreenshotButton from '../components/UpdateScreenshotButton'

export default {
  components: { UpdateScreenshotButton, PlayableListItem},
  data () {
    return {
      iframeHeight: 300
    }
  },
  computed: {
    ...mapGetters({
      playable: 'currentPlayable',
      isLoading: 'isCurrentPlayableLoading'
    }),
    playableLinks () {
      return this.playable.links.filter(
        item => item.url !== this.playable.url
      ).map(item => {
        item.name = item.s3_key.replace(this.playable.s3_key, '')
        return item
      }).sort((a, b) => {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
    },
    playableScreenshots() {
      return this.playable.screenshots;
    }
  },
  filters: {
    humanizePlayableLink (value) {
      return value.replace(this.playable.s3_key, '')
    }
  },
  methods: {
    ...mapActions([
      'fetchPlayable'
    ]),
    ...mapMutations({
      clearPlayable: 'CLEAR_CURRENT_PLAYABLE'
    }),
    handleBackButton () {
      this.$router.push({name: 'Playables'})
    },
    handleResize () {
      const containerWidth = this.$refs.iframe_container
        ? this.$refs.iframe_container.clientWidth
        : 668
      this.iframeHeight = (containerWidth / 16) * 9
    }
  },
  mounted () {
    this.fetchPlayable()
      .catch(error => this.$eventHub.$emit('error-request-notify', error))
    window.addEventListener('resize', () => { this.handleResize() })
    this.handleResize()
  },
  destroyed () {
    this.clearPlayable()
  }
}
</script>

<style scoped>
  .qr-code {
    width: 100%;
  }

  .links-title {
    font-size: 18px;
  }

  .playable-link {
    display: block;
    margin-top: 1px;
    font-size: 16px;
  }

  .playable-links {
    text-align: left;
  }
</style>
